(function () {
  'use strict';

  var form      = document.querySelector('[data-ls-search-form]');
  var input     = document.querySelector('[data-ls-search-input]');
  var panel     = document.getElementById('ls-search-panel');
  var overlay   = document.getElementById('ls-search-overlay');
  var clearBtn  = document.querySelector('[data-ls-search-clear]');

  if (!form || !input || !panel) return;

  var _scfg = window.lsSearchConfig || {};
  var POPULAR = (_scfg.popularTerms || 'Shampoo|Hair mask|Conditioner|Face cream|Perfume|Vitamin C serum|Body lotion|Hair oil|Serum|Sunscreen').split('|');
  var POPULAR_LABEL = _scfg.popularLabel || 'Popular searches';

  var debounceTimer = null;
  var focusedIndex  = -1;
  var currentLinks  = [];

  // ── open / close ──────────────────────────────────────────────

  function open() {
    // close any open mega menu panel first
    document.querySelectorAll('.hn__mega.is-open').forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    var megaOverlay = document.getElementById('ls-mega-overlay');
    if (megaOverlay) megaOverlay.classList.remove('is-active');
    document.querySelectorAll('[data-mega].is-active').forEach(function (i) { i.classList.remove('is-active'); });

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    form.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    if (input.value.trim() === '') showPopular();
  }

  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    form.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    focusedIndex = -1;
    currentLinks = [];
  }

  // ── popular searches ──────────────────────────────────────────

  function showPopular() {
    var html = '<div class="ls-search__inner">'
      + '<p class="ls-search__label">' + POPULAR_LABEL + '</p>'
      + '<div class="ls-search__chips">';
    POPULAR.forEach(function (term) {
      html += '<button type="button" class="ls-search__chip" data-term="'
        + esc(term) + '">' + esc(term) + '</button>';
    });
    html += '</div></div>';
    panel.innerHTML = html;
    currentLinks = [];
    focusedIndex  = -1;

    panel.querySelectorAll('[data-term]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = btn.dataset.term;
        syncClearBtn();
        fetchResults(btn.dataset.term);
      });
    });
  }

  // ── search ────────────────────────────────────────────────────

  function search(q) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { fetchResults(q); }, 220);
  }

  function fetchResults(q) {
    if (!q) { showPopular(); return; }

    var predictiveUrl = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product'
      + '&resources[limit]=9'
      + '&resources[options][prefix]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';

    var countUrl = '/search?section_id=ls-search-count'
      + '&q=' + encodeURIComponent(q)
      + '&type=product'
      + '&options[prefix]=last';

    Promise.all([
      fetch(predictiveUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      fetch(countUrl,      { credentials: 'same-origin' }).then(function (r) { return r.text(); })
    ])
      .then(function (results) {
        var data      = results[0];
        var countHtml = results[1];
        var products  = (data.resources
          && data.resources.results
          && data.resources.results.products) || [];
        var match      = countHtml.match(/>\s*(\d+)\s*</);
        var totalCount = match ? parseInt(match[1], 10) : null;
        renderResults(products, q, totalCount);
      })
      .catch(function () { renderNoResults(q); });
  }

  // ── helpers ───────────────────────────────────────────────────

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(price) {
    var n = parseFloat(price);
    return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €';
  }

  function thumbUrl(p) {
    var raw = p.image || p.featured_image;
    if (!raw) return '';
    var url = (typeof raw === 'string') ? raw : raw.url;
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.split('?')[0] + '?width=128';
  }

  function searchUrl(q) {
    // type=product BŪTINAS — be jo Shopify grąžina ir puslapius/straipsnius,
    // o rezultatų tinklelis juos piešia prekės kortele („Sold out", be foto).
    return (window.routes ? window.routes.searchUrl : '/search')
      + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
  }

  // ── render ────────────────────────────────────────────────────

  function renderResults(products, q, totalCount) {
    focusedIndex = -1;
    if (!products.length) { renderNoResults(q); return; }

    var countLabel = totalCount !== null ? String(totalCount) : (products.length >= 9 ? '9+' : String(products.length));
    var html = '<div class="ls-search__inner">'
      + '<p class="ls-search__label">' + (_scfg.products || 'Products') + '</p>'
      + '<div class="ls-search__results" role="listbox">';

    products.forEach(function (p, i) {
      var src   = thumbUrl(p);
      var price = p.price ? formatMoney(p.price) : '';
      html += '<a class="ls-search__result" href="' + esc(p.url)
        + '" role="option" aria-selected="false" data-index="' + i + '">';
      if (src) {
        html += '<div class="ls-search__result-img">'
          + '<img src="' + esc(src) + '" alt="" width="56" height="56" loading="lazy"></div>';
      } else {
        html += '<div class="ls-search__result-img ls-search__result-img--empty"></div>';
      }
      html += '<div class="ls-search__result-info">';
      if (p.vendor) html += '<span class="ls-search__result-vendor">' + esc(p.vendor) + '</span>';
      html += '<span class="ls-search__result-title">' + esc(p.title) + '</span>';
      if (price)    html += '<span class="ls-search__result-price">' + price + '</span>';
      html += '</div></a>';
    });

    html += '</div>'
      + '<a class="ls-search__view-all" href="' + esc(searchUrl(q)) + '">'
      + (_scfg.viewAll || 'View all results for “{terms}” ({count}) →').replace('{terms}', esc(q)).replace('{count}', countLabel) + '</a>'
      + '</div>';

    panel.innerHTML = html;
    currentLinks = Array.from(panel.querySelectorAll('.ls-search__result'));
  }

  function renderNoResults(q) {
    panel.innerHTML = '<div class="ls-search__inner">'
      + '<p class="ls-search__no-results">' + (_scfg.noResults || 'No results for "{{terms}}"').replace('{{terms}}', '<strong>' + esc(q) + '</strong>') + '</p>'
      + '<a class="ls-search__view-all" href="' + esc(searchUrl(q))
      + '">' + (_scfg.searchAll || 'Search all content →') + '</a>'
      + '</div>';
    currentLinks = [];
    focusedIndex  = -1;
  }

  // ── keyboard navigation ───────────────────────────────────────

  function moveFocus(dir) {
    if (!currentLinks.length) return;
    currentLinks.forEach(function (el) {
      el.classList.remove('is-focused');
      el.setAttribute('aria-selected', 'false');
    });
    if (focusedIndex === -1) {
      focusedIndex = dir > 0 ? 0 : currentLinks.length - 1;
    } else {
      focusedIndex = (focusedIndex + dir + currentLinks.length) % currentLinks.length;
    }
    var active = currentLinks[focusedIndex];
    active.classList.add('is-focused');
    active.setAttribute('aria-selected', 'true');
    active.scrollIntoView({ block: 'nearest' });
  }

  // ── events ────────────────────────────────────────────────────

  input.addEventListener('focus', function () {
    if (!panel.classList.contains('is-open')) open();
  });

  function syncClearBtn() {
    form.classList.toggle('has-value', input.value.length > 0);
  }

  input.addEventListener('input', function () {
    if (!panel.classList.contains('is-open')) open();
    syncClearBtn();
    var q = input.value.trim();
    if (q.length < 1) {
      showPopular();
    } else {
      search(q);
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      syncClearBtn();
      close();
      input.blur();
    });
  }

  input.addEventListener('keydown', function (e) {
    if (!panel.classList.contains('is-open')) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      moveFocus(1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      moveFocus(-1);
    } else if (e.key === 'Enter') {
      if (focusedIndex >= 0 && currentLinks[focusedIndex]) {
        e.preventDefault();
        close();
        window.location.href = currentLinks[focusedIndex].href;
      } else {
        close();
      }
    } else if (e.key === 'Escape') {
      close();
      input.blur();
    }
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      close();
      input.blur();
    });
  }

  document.addEventListener('click', function (e) {
    if (!panel.classList.contains('is-open')) return;
    if (!form.contains(e.target) && !panel.contains(e.target)) {
      close();
    }
  });

  form.addEventListener('submit', function () {
    close();
  });
})();
